import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  AnalyzeCsvRequest,
  AnalyzeCsvResponse,
  ImportAudienceContext,
} from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export type AnalyzeAudienceCsvParams = AnalyzeCsvRequest<ImportAudienceContext>;

export const analyzeAudienceCsv = async (
  params: AnalyzeAudienceCsvParams
): Promise<AnalyzeCsvResponse> => {
  return await tinctApi.audiences.analyzeCsv(params);
};

export const useAnalyzeAudienceCsv = (
  options?: Omit<
    UseMutationOptions<AnalyzeCsvResponse, ApiError, AnalyzeAudienceCsvParams>,
    'mutationFn'
  >
) =>
  useMutation({
    mutationFn: analyzeAudienceCsv,
    ...options,
  });
